export default __webpack_public_path__ + "static/media/abput_hero_bg.cce04934.png";